import type { FormKitNode } from '@formkit/core'

// This is a little custom plugin as a workaround for the following case:
// When having a group of radio buttons inside a "repeater", the names of the
// elements are not made unique. This leads to having the same radio option
// with the same name multiple times on the page, making clicking one select
// all radios with the same name as well.
// This plugin adds and increments a number to the name of each radio button.
export function createRadioAltPlugin() {
  let count = 0

  return function (node: FormKitNode) {
    if (node.props.type === 'radio') {
      node.props.altName = `radio_number_${count}`
      count++
    }
  }
}
